import { TranslateService } from "@ngx-translate/core";

export class TelephoneHelper {
	public static prefix: string = "+55";
	public static mask: string = "(00) 0000-0000 || (00) 0 0000-0000";

	constructor(private translateService: TranslateService) {
		this.translateService.get(['FORMATTER.TELEPHONE.MASK', 'FORMATTER.TELEPHONE.PREFIX']).subscribe((translated => {
			console.log('TelephoneHelper | Translated', translated);
			if (translated != undefined && typeof translated === "object") {
				TelephoneHelper.mask = translated['FORMATTER.TELEPHONE.MASK'];
				TelephoneHelper.prefix = translated['FORMATTER.TELEPHONE.PREFIX'];
			}
		}));
	}

	public static format(plain: string): string {
		var result = plain.replace(TelephoneHelper.prefix, '').replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
		return result != null ? '(' + result[1] + ') ' + result[2] + ' ' + result[3] : ''
	}

	public static unformat(formatted: string): string {
		return TelephoneHelper.prefix + formatted.replace(/\D/g, '');
	}
}